import React, { useContext } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerContent,
  DrawerCloseButton,
  Button,
  Text,
  Flex,
  VStack,
} from '@chakra-ui/react';
import { MdLockOutline } from 'react-icons/md';

import { CartContext } from '@rsc/contexts';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';
import Image from '@rsc/ui-components/tailwind/Image';

const decodeHtml = html => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

function CartToast() {
  const {
    cart,
    setCartActive,
    hideToast,
    showToast,
    toastProduct,
    toastAddOns,
  } = useContext(CartContext);
  const { tt, localizePrice } = useUiComponentsInternationalContext();

  if (!toastProduct || !toastProduct.merchandise) return null;

  let price = toastProduct.merchandise.price?.amount || 0;

  // Product is a subscription, that has discounted price
  if (
    toastProduct?.sellingPlanAllocation?.priceAdjustments?.[0]?.price?.amount
  ) {
    price = toastProduct.sellingPlanAllocation.priceAdjustments[0].price.amount;
  }

  const formattedPrice = localizePrice(price);

  return (
    <Drawer isOpen={showToast} placement="right" onClose={hideToast}>
      <DrawerContent
        w={{
          base: '90%',
          sm: '25rem',
        }}
        maxW={{
          base: '90%',
          sm: '25rem',
        }}
        top="1rem !important"
        bottom="1rem !important"
        right={{
          base: '5% !important',
          sm: '1rem !important',
        }}
        borderRadius="lg"
        overflow="hidden"
      >
        <DrawerHeader
          as={Flex}
          background="brand.ink"
          color="white"
          width="full"
          align="center"
          justify="space-between"
        >
          <Text fontSize="1rem">{tt(s => s.cartCommon.itemAddedToCart)}</Text>
          <DrawerCloseButton pos="initial" color="white" />
        </DrawerHeader>

        <DrawerBody as={VStack} p={6} gap={toastAddOns ? 4 : 8} h="full">
          <Flex
            gap={5}
            borderBottom="1px solid"
            borderColor="stroke.light"
            pb={6}
            w="full"
          >
            {toastProduct.merchandise.image?.src && (
              <Image
                alt={toastProduct.merchandise.product.title}
                src={`${toastProduct.merchandise.image.src}&width=128`}
                width="5rem"
              />
            )}
            <VStack align="flex-start" spacing={1}>
              <Text>{decodeHtml(toastProduct.merchandise.product.title)}</Text>
              <Text>
                {tt(s => s.cartCommon.priceEach, { price: formattedPrice })}
              </Text>
            </VStack>
          </Flex>

          {toastAddOns?.map(ao => (
            <Flex
              w="full"
              borderRadius="lg"
              bg="neutral.50"
              p="2"
              key={ao._key}
              h="auto"
            >
              <Flex align="center">
                <Image className="ml-2" src={ao.imageUrl} width="64px" />
                <VStack align="flex-start" ml="4">
                  <Text textStyle="caption" color="brand.ink" fontWeight="bold">
                    {ao.title}
                  </Text>
                  <Text
                    textStyle="caption"
                    fontWeight="bold"
                    color="typography.base"
                  >
                    {localizePrice(ao.price)}
                  </Text>
                </VStack>
              </Flex>
            </Flex>
          ))}

          <VStack w="full">
            <Button
              variant="secondary"
              mb={6}
              onClick={() => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'gatsby-begin-checkout',
                });
                localStorage.setItem('checkoutActive', true);
                window.location.href = cart.checkoutUrl;
              }}
              leftIcon={<MdLockOutline size="24" />}
            >
              {tt(s => s.cartDeptComponents.checkoutButton)}
            </Button>
            <Button
              variant="link"
              fontSize="1rem"
              color="brand.ink"
              onClick={hideToast}
            >
              {tt(s => s.cartDeptComponents.continueShoppingButton)}
            </Button>
            <Button
              variant="link"
              fontSize="1rem"
              color="brand.ink"
              onClick={() => setCartActive(true)}
            >
              {tt(s => s.cartDeptComponents.viewCartButton)}
            </Button>
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}

export default CartToast;
